import React from 'react'
import { Button } from 'react-bootstrap'
import { FaEdit, FaTrash } from 'react-icons/fa'
import { COLORS } from '../../../constants/colors'
import './CreditCardStyles.css'

function CreditCardDetails({card, pvCardNumber, updateModalShow, deleteModalShow}) {
    // Determine card type based on first digit
    const cardType = pvCardNumber.startsWith('4') ? 'visa' : 'mastercard';
    const cardLogo = cardType === 'visa' 
        ? 'https://raw.githubusercontent.com/slaterjohn/payment-logos/master/Rounded%20Corners/PNG/medium/visa@2x.png'
        : 'https://raw.githubusercontent.com/slaterjohn/payment-logos/master/Rounded%20Corners/PNG/medium/mastercard@2x.png';

    // Determine if it's a debit or credit card
    const isDebitCard = card.cardType === 'debit';
    const cardClass = isDebitCard ? 'debit-card' : 'credit-card';

    return (
        <>
            <div className="d-flex justify-content-end mb-1">
                <Button className="edit" onClick={updateModalShow}>
                    <FaEdit size={16} className="me-1" />
                </Button>
                <Button className="delete" onClick={deleteModalShow}>
                    <FaTrash size={16} className="me-1" />
                </Button>
            </div>
        
            <div className={`${cardClass} ${cardType}`}>
                <div className="card-chip"></div>
                <div className="hologram"></div>
                <div className="card-number">{pvCardNumber}</div>
                <div className="card-holder">Name:{card.cardOwner}</div>
                <div className="card-expiry">Expires: {card.expDate}</div>
                <img src={cardLogo} alt={cardType} className="card-logo" />
                <div className="card-issuer">Pigeon Auction Bank Card</div>
                <div className="security-pattern"></div>
                <div className="debit-badge">{isDebitCard ? 'DEBIT' : 'CREDIT'}</div>
            </div>
        </>
    )
}

export default CreditCardDetails
